import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token');
      if (window.location.pathname.startsWith('/admin') && window.location.pathname !== '/admin/login') {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (email, password) => api.post('/auth/login', { email, password });
export const verifyAuth = () => api.get('/auth/verify');

// Categories
export const getCategories = () => api.get('/categories');
export const createCategory = (data) => api.post('/categories', data);
export const deleteCategory = (id) => api.delete(`/categories/${id}`);

// Blog Posts
export const getPosts = (publishedOnly = false, categoryId = null) => {
  const params = new URLSearchParams();
  if (publishedOnly) params.append('published_only', 'true');
  if (categoryId) params.append('category_id', categoryId);
  return api.get(`/posts?${params.toString()}`);
};
export const getPost = (id) => api.get(`/posts/${id}`);
export const getPostBySlug = (slug) => api.get(`/posts/slug/${slug}`);
export const createPost = (data) => api.post('/posts', data);
export const updatePost = (id, data) => api.put(`/posts/${id}`, data);
export const deletePost = (id) => api.delete(`/posts/${id}`);

// Comments
export const getComments = (status = null) => {
  const params = status ? `?status=${status}` : '';
  return api.get(`/comments${params}`);
};
export const getPostComments = (postId, approvedOnly = true) => 
  api.get(`/posts/${postId}/comments?approved_only=${approvedOnly}`);
export const createComment = (data) => api.post('/comments', data);
export const updateCommentStatus = (id, status) => api.put(`/comments/${id}/status?status=${status}`);
export const deleteComment = (id) => api.delete(`/comments/${id}`);

// Contact Submissions
export const getContactSubmissions = () => api.get('/contact-submissions');
export const createContactSubmission = (data) => api.post('/contact', data);
export const deleteContactSubmission = (id) => api.delete(`/contact-submissions/${id}`);

// Support Requests
export const getSupportRequests = () => api.get('/support-requests');
export const createSupportRequest = (data) => api.post('/support-request', data);
export const deleteSupportRequest = (id) => api.delete(`/support-requests/${id}`);

// Partnership Inquiries
export const getPartnershipInquiries = () => api.get('/partnership-inquiries');
export const createPartnershipInquiry = (data) => api.post('/partnership', data);
export const deletePartnershipInquiry = (id) => api.delete(`/partnership-inquiries/${id}`);

// Dashboard Stats
export const getDashboardStats = () => api.get('/dashboard/stats');

// Image Upload
export const uploadImage = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/upload/image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

// Seed Categories
export const seedCategories = () => api.post('/seed/categories');

// CSV Export URLs
export const getExportUrl = (type) => `${API_URL}/api/export/${type}`;

export default api;
